module.exports = __webpack_public_path__ + "img/share_icon_yaogongbi@2x.6c1edd50.png";